import { useApiClient } from "@myplant-io/utils/api";
import { useQuery } from "react-query";
import { ModeStoreEntry } from "../types";

export function useModeStoreEntries() {
  const client = useApiClient();
  return useQuery<ModeStoreEntry[]>("mode-store", async () =>
    client.fetch("/api/mode-store")
  );
}
